import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogBody } from '@dev/ee-components';

import Props from './DeleteSuppressionModalInterface';

const DeleteSuppressionModal: FC<Props> = (): JSX.Element => {
    const { t } = useTranslation();
    return (
        <DialogBody above={t('deleteselectedemails')} variant="alert">
            {t('actioncannotbeundone')}
        </DialogBody>
    );
};

export default DeleteSuppressionModal;
